module.exports = __webpack_public_path__ + "storeHome/img/id-limitedImg-1111.24e839f0.png";